import {useEffect} from 'react';
import {usePrev} from "./usePrev";

export function useEffectOnPositiveChange(value, callback) {
  const prevValue = usePrev(value);

  useEffect(() => {
    if (prevValue === false && value === true) {
      callback(prevValue, value);
    }
  }, [prevValue, value, callback]);
}